/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AddressMasterEditor extends Common.GridEditorBase<AddressMasterRow> {
        protected getColumnsKey() { return "OMS.AddressMaster"; }
        protected getDialogType() { return AddressMasterDialog; }
        protected getLocalTextPrefix() { return AddressMasterRow.localTextPrefix; }
        protected getInsertPermission() { return AddressMasterRow.insertPermission; }
        protected getUpdatePermission() { return AddressMasterRow.updatePermission; }
        protected getDeletePermission() { return AddressMasterRow.deletePermission; }
        protected useViewMode() { return true; }

        constructor(container: JQuery) {
            super(container);
        }
        public getColumns() {

            var columns = super.getColumns();

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);

            if (target.hasClass('check-box no-float readonly') || target.hasClass('check-box no-float readonly checked'))
                target.removeClass('readonly')

            if (target.hasClass('check-box no-float')) {
                if (item.Default == true) {
                    item.Default = false;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                }
                else {
                    item.Default = true;
                    this.view.updateItem(id, item);
                    this.view.refresh();

                }
            }
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        this.view.deleteItem(id);
                        this.view.refresh();
                    });
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }
        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons[0].title = 'Add Address';
            return buttons;
        }

    }
}